import { createSlice } from "@reduxjs/toolkit";
import { MasterSlice } from "types/master";
import { fetchRegionsList } from "./thunk";
import { fetchAgencyMasterThunk, fetchUser } from "slices/auth/thunk";

const initialState : MasterSlice = {
    regions: {
        value: [],
        last_fetched_at: null,
        error: null,
        loading: false
    },
    configurations: {
        notification_preferences: []
    },
    languages: {}
}

const masterData = createSlice({
    name: 'master',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchRegionsList.pending, (state) => {
            state.regions.loading = true;
            state.regions.error = null;
        })
        .addCase(fetchRegionsList.fulfilled, (state, action) => {
            state.regions.loading = true;
            state.regions.error = null;

            state.regions.value = action.payload;
            state.regions.last_fetched_at = Date.now();

        })
        .addCase(fetchRegionsList.rejected, (state, action) => {
            state.regions.loading = false;
            state.regions.error = action.payload || "An error occurred while fetching regions data";
        })

        .addCase(fetchUser.fulfilled, (state, {payload}) => {
            const { master, configurations } = payload;
            state.languages = master.language_list;
            state.configurations = configurations;
        })
        .addCase(fetchAgencyMasterThunk.fulfilled, (state, {payload}) => {
            const {language_list} = payload;
            state.languages = language_list;
        })
    }
})

export default masterData.reducer